<div class="container">
  <div class="header">
    <div class="filters flex">
      <div class="availability-zone-filter filter">
        <label>Select Zones: </label>
        <icn-dropdown
          [allowMultiple]="true"
          [position]="'bottom'"
          [showSelection]="false"
          [selectedValues]="vm.selectedAvailabilityZoneIds"
          (selectedValuesChange)="vm.onAvailabilityZoneChanged()"
        >
          <icn-dropdown-item
            *ngFor="let availabilityZone of vm.allAvailabilityZones"
            [value]="availabilityZone.id"
            [title]="availabilityZone.displayName"
            [textColor]="availabilityZone.colorHex"
          >
          </icn-dropdown-item>
        </icn-dropdown>
      </div>
      <div class="channels-filter filter">
        <label>Select Channels: </label>
        <icn-dropdown
          [allowMultiple]="true"
          [position]="'bottom'"
          [showSelection]="false"
          [(selectedValues)]="vm.selectedChannelIds"
        >
          <icn-dropdown-item
            *ngFor="let channel of vm.visibleChannels"
            [value]="channel.id"
            [title]="channel.name"
          >
          </icn-dropdown-item>
        </icn-dropdown>
      </div>
      <div class="error-type-filter filter">
        <label>Error Types: </label>
        <icn-dropdown
          [allowMultiple]="true"
          [showSelection]="false"
          [position]="'bottom'"
          [(selectedValues)]="vm.selectedErrorTypesIds"
        >
          <icn-dropdown-item [value]="2147483647" [title]="'Zero Bitrate'">
          </icn-dropdown-item>
        </icn-dropdown>
      </div>

      <div class="dates-filter from filter">
        <label>From: </label>
        <dateinput
          [(current)]="vm.selectedFromDate"
          [noTimePicker]="true"
        ></dateinput>
      </div>
      <div class="dates-filter filter">
        <label>To: </label>
        <dateinput
          [(current)]="vm.selectedToDate"
          [noTimePicker]="true"
        ></dateinput>
      </div>

      <div class="buttons">
        <label></label>
        <ichannel-button
          [theme]="'DARK'"
          [callback]="vm.refreshButtonClicked.bind(vm)"
          [label]="'Show'"
        ></ichannel-button>
      </div>
    </div>
  </div>
  <div class="body">
    <table class="errors-table">
      <thead>
        <tr>
          <th>Time</th>
          <th>Resolve Time</th>
          <th>Availability Zone</th>
          <th>Channel Name</th>
          <th>Platform Name</th>
          <th>Count</th>
          <th>Severity</th>
          <th>Message</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let error of vm.errors">
          <td>{{ vm.formatTime(error.createdTime) }}</td>
          <td>{{ vm.formatTime(error.resolvedTime) }}</td>
          <td>{{ error.availabilityZoneName }}</td>
          <td>{{ error.channelName }}</td>
          <td>{{ error.platformName }}</td>
          <td>{{ error.count }}</td>
          <td>{{ error.severity }}</td>
          <td>{{ error.msg }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
